import React from 'react';
import Img from 'gatsby-image';
import { uid } from 'react-uid';
import { graphql } from 'gatsby';
import { startFree } from '../../../utils/pricing';
import SendGridLink from '../../SendGridLink';
import {
  StyledHeader,
  StyledGridRow,
  StyledHeroContent,
  StyledHeroMedia,
  StyledButtonList,
  StyledCta,
} from './styles';
import Lottie from 'lottie-react-web';
import heroAnimation from './heroAnimation.json';

const GlobalContentBlocksHeroBlock = ({ block, optimizeVariant }) => {
  return (
    <StyledHeader>
      <StyledGridRow className="row">
        <StyledHeroContent>
          <span className="supertext">Twilio SendGrid</span>
          {block.headline && (
            <h1
              className="m-top-6 m-bottom-6 is-regular"
              dangerouslySetInnerHTML={{ __html: block.headline }}
            />
          )}
          {block.subheadline && (
            <h3
              className="hero__subhead m-bottom-6 is-regular"
              dangerouslySetInnerHTML={{ __html: block.subheadline }}
            />
          )}

          <StyledButtonList>
            <SendGridLink
              id="home-pricing-cta"
              to="/pricing/"
              className="btn btn--primary btn--large"
              data-gtm-track="true"
              data-gtm-event-type="cta"
            >
              Start For Free
            </SendGridLink>
            <StyledCta>
              <SendGridLink
                //to={block.ctaUrl}
                onClick={startFree}
                className="arrow-link"
                data-gtm-track="true"
                data-gtm-cta-type="free"
                data-gtm-event-type="cta"
              >
                See Plans &amp; Pricing
              </SendGridLink>
            </StyledCta>
          </StyledButtonList>
        </StyledHeroContent>
        <StyledHeroMedia>
          {block.media.map((media) => {
            const mediaType = media.fieldGroupName.split('_').pop();
            switch (mediaType) {
              case 'Animation':
                const animation = media.lottieAnimation;
                switch (animation) {
                  case 'home-hero-animation':
                    return (
                      <div key={uid(media)}>
                        <div
                          className="low-motion-hide"
                          aria-label="Animation of two professionals sitting in an office sending emails using SendGrid products"
                        >
                          <Lottie
                            options={{
                              animationData: heroAnimation,
                              loop: true,
                              rendererSettings: {
                                preserveAspectRatio: 'none',
                              },
                            }}
                            speed={1}
                          />
                        </div>
                        <Img
                          className="low-motion-show"
                          fluid={
                            media.fallbackImage.imageFile.childImageSharp.fluid
                          }
                          alt={media.fallbackImage.altText}
                        />
                      </div>
                    );

                  default:
                    return null;
                }
              case 'Image':
                return (
                  <StyledMedia key={uid(media)}>
                    <Img
                      fluid={media.file.imageFile.childImageSharp.fluid}
                      alt={media.file.altText}
                    />
                  </StyledMedia>
                );
              default:
                return null;
            }
          })}
        </StyledHeroMedia>
      </StyledGridRow>
    </StyledHeader>
  );
};

export default GlobalContentBlocksHeroBlock;

export const query = graphql`
  fragment HeroBlockFragment on WPGraphQL_Page {
    acfGlobalContentBlocks {
      contentBlocks {
        ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_HeroBlock {
          fieldGroupName
          headline
          layout
          media {
            ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_HeroBlock_Media_Image {
              fieldGroupName
              file {
                altText
                sourceUrl
                imageFile {
                  childImageSharp {
                    fluid(maxWidth: 460) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
            ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_HeroBlock_Media_Animation {
              fieldGroupName
              lottieAnimation
              fallbackImage {
                altText
                sourceUrl
                imageFile {
                  childImageSharp {
                    fluid(maxWidth: 460) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
          subheadline
        }
      }
    }
  }
`;
